import React from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import { AssetsFileFormViewModel } from './assets-file-form.viewmodel';
import { SUPPORTED_ASSETS_IMAGE_TYPES } from '../../../../../constants/file.constants';
import UploadImage from '../../shared/upload-image/upload-image';
import { getFileType } from '../../../../../infrastructure/utils/common.utils';
import DefaultButton from '../../../../global/default-button/default-button';

import './assets-file-form.scss';

interface Props {
    vm: AssetsFileFormViewModel;
}

export const AssetsFileFormPresentation = observer((props: Props): JSX.Element => {
    const { vm } = props;
    const { file, permissionToUpdate, permissionToDownload, organizationId, attendeeId, isLoadingDownload } = vm;
    const supportedImageTypesWithoutTiff = SUPPORTED_ASSETS_IMAGE_TYPES.filter(type => type !== 'image/tiff').join();
    const isImage = file && (supportedImageTypesWithoutTiff.includes(getFileType(file.title)));

    const onApply = (): void | null => {
        vm.downloadAsset();
    };

    const isSpeakerAsset = organizationId !== null && attendeeId !== null;
    return (
        <div className='assets-download-file-form-in-popover'>
            <div className='assets-download-file-form-in-popover__content'>
                <div className='assets-download-file-form-in-popover__label'>
                    <FormattedMessage description='Label text' defaultMessage='File' id='oe.common.file' />
                </div>
                <UploadImage
                    imgSrc={isImage ? vm.assetDownloadUrl : ''}
                    imgName={file?.title || ''}
                    onChange={(permissionToUpdate && isSpeakerAsset) ? e => vm.replaceSpeakerAssetImage(e.target.files[0]) : null}
                    deleteImage={permissionToUpdate ? vm.deleteAssetImage : null}
                />
            </div>
            {permissionToDownload && <div className='oe-popup-layout__footer'>
                <div className='buttons-block buttons-block--from-right'>
                    <DefaultButton
                        text={<FormattedMessage description='Button label text' defaultMessage='Download' id='oe.common.download' />}
                        modifier={['fat', 'confirm-safe']}
                        onClick={onApply}
                        disabled={isLoadingDownload || !vm.assetDownloadUrl}
                    />
                </div>
            </div>}
        </div>
    );
});
